import { RectificationStatus } from "../graphql"

export const getRectificationStatusColorScheme = (status: RectificationStatus) => {
	switch (status) {
		case RectificationStatus.Pending:
			return "yellow"

		case RectificationStatus.Ongoing:
			return "purple"

		case RectificationStatus.UnderReview:
			return "blue"

		case RectificationStatus.Completed:
			return "green"

		default:
			return "gray"
	}
}
